module.exports = __webpack_public_path__ + "img/pattern-lines.18be1793.svg";